// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__BUA8a","head":"ProcedureTableInfo_head__35mTH"};